import { render } from "./DefaultSvgClose.vue?vue&type=template&id=60d6734c&scoped=true"
import script from "./DefaultSvgClose.vue?vue&type=script&lang=js"
export * from "./DefaultSvgClose.vue?vue&type=script&lang=js"

import "./DefaultSvgClose.vue?vue&type=style&index=0&id=60d6734c&lang=scss&scoped=true"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d6734c"]])

export default __exports__